// extracted by mini-css-extract-plugin
export default {"imgContain":"HQ","content":"IQ","titleAndImage":"JQ","title":"KQ","text":"LQ","rhodeTitle":"MQ","shortHR":"NQ","modal_root":"OQ","x_mark":"PQ","flavorStickModal":"QQ","greenBox":"RQ"};
    if(module.hot) {
      // 1726593107023
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  